exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newTopic .topicDetail[data-v-1080b174]{padding:18px 20px}.newTopic .topic-form[data-v-1080b174]{max-width:760px}.upload-preview[data-v-1080b174]{margin-top:10px;width:72px;height:72px;border-radius:4px;object-fit:cover}.supload-tips[data-v-1080b174]{margin-top:6px;color:#8391a5;font-size:12px;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1080b174&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/topic/newTopic.vue
// module id = 443
// module chunks = 0